import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ContentGenerationScreen = lazy(
  () => import('~/features/item-setup/pages/content-generation-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/content-generation')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ContentGenerationScreen />
    </Suspense>
  ),
});
